import { selectFormById, selectFormRevisionById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { formRevisionSettingsDetailViewStaticData } from "src/views/FormRevisionSettingsDetailView/constants"
import { FormRevisionSettingsDetailView } from "src/views/FormRevisionSettingsDetailView/FormRevisionSettingsDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/revisions/$formRevisionId",
)({
	component: FormRevisionSettingsDetailView,
	staticData: formRevisionSettingsDetailViewStaticData,
	loader: ({ params }) => {
		const form = selectFormById(params.formId)(appStore.getState())
		const formRevision = selectFormRevisionById(params.formRevisionId)(appStore.getState())

		if (!form || !formRevision || formRevision.form !== form.uuid) throw notFound()
	},
})
